const BLACKLIST = {
  PAGE_TITLE: 'لیست سیاه | رایچت',

  HEADING_TITLE: 'لیست سیاه',
  HEADING_SUBTITLE: 'کاربرانی که بلوکه شده‌اند در این لیست نمایش داده می‌شوند.',

  MORE_INFO: 'اطلاعات بیشتر',
  DELETE_ALL_FROM_BLACK_LIST: 'حذف همه از لیست سیاه',
  DELETE_FROM_BLACK_LIST: 'حذف از لیست سیاه',
  DELETE_FROM_BLACK_LIST_CONFIRM:
    'آيا تاييد می كنيد اين كاربر از ليست سياه حذف شود؟',
  NO_BLOCKED_USER: 'در حال حاضر هيچ کاربری بلوكه نيست.',

  CONFIRM_MODAL_CANCEL: 'انصراف',
  CONFIRM_MODAL_CONFIRM: 'تاييد',

  REMOVE_ALL_CONFIRM_TEXT:
    'آيا تاييد می كنيد همه كاربران بلوكه شده از ليست سياه حذف شوند؟',
};

export default BLACKLIST;
